import React from 'react'
import ReactMarkdown from 'react-markdown'

import parseUserAgent from './parse-user-agent'
import * as check from './check'


export default class Browser extends React.Component {
  render () {
    const userAgent = parseUserAgent(),
          {
            browser: {
              name: browserName,
              version: browserVersion
            },
            os: {
              name: osName,
              version: osVersion
            }
          } = userAgent

    const testResult = check.browser(userAgent.browser)

    return (
      <tr key={'browserCheck'}>
        <td>Browser</td>
        <check.Check status={testResult.status} />
        <td>
          <div>
            <ul>
              <li>Browser: {browserName}</li>
              <li>Version: {browserVersion}</li>
              <li>Platform: {osName} {osVersion}</li>
            </ul>
          </div>
        </td>
        <td>
          <ReactMarkdown source={testResult.text} />
        </td>
      </tr>)
  }
}


// WEBPACK FOOTER //
// ./app/browser.js